import {CompassOutlined, FileImageOutlined, FileOutlined, VideoCameraOutlined} from '@/icons';

export const attaches = [
    {
        value: '链接',
        icon: <CompassOutlined />,
        key: 0,
        msgType: 'LINK',
    },
    {
        value: '图片',
        icon: <FileImageOutlined />,
        key: 1,
        msgType: 'IMAGE',
    },
    {
        value: '视频',
        icon: <VideoCameraOutlined />,
        key: 2,
        msgType: 'VIDEO',
    },
    {
        value: '文件',
        icon: <VideoCameraOutlined />,
        key: 3,
        msgType: 'FILE',
    },
    {
        value: '小程序',
        icon: <VideoCameraOutlined />,
        key: 4,
        msgType: 'WEBAPP',
    },
];
